import { notification, Drawer, Col } from 'antd'
import { Form, FormItem, Input, Select, SubmitButton } from 'formik-antd'
import { Formik, FormikHelpers } from 'formik'

import { httpClient } from '../../../util/http-client'
import { drawerAndModalWidth } from '../../../util/guideline'
import { filterProps } from '../../../components/forms/utils'
import { CustomerFormValues, KycCustomer } from '../models'
import { segmentTypeOptions, validationSchema } from './validation'
import { messages } from '../messages'

interface Props {
  customer: KycCustomer
  isVisible: boolean
  onSuccess: () => void
  onClose: () => void
}

export const UpdateKycCustomerDrawer = ({ customer, onSuccess, onClose, isVisible }: Props) => {
  const onSubmit = async (
    values: CustomerFormValues,
    { setSubmitting, resetForm }: FormikHelpers<CustomerFormValues>,
  ) => {
    try {
      await httpClient(`/kyc/${customer.id}`, { method: 'PUT', data: values })
      notification.success({ message: messages.common.success, description: messages.kycCustomers.update.success })
      resetForm()
      onSuccess()
    } catch (error) {
      notification.error({ message: messages.common.error, description: messages.kycCustomers.update.error })
    } finally {
      setSubmitting(false)
    }
  }

  return (
    <Drawer
      title="Update KYC Customer"
      className="update-kyc-customer"
      placement="right"
      onClose={onClose}
      open={isVisible}
      width={drawerAndModalWidth}
      destroyOnClose
    >
      <Col xs={24}>
        <Formik initialValues={customer} validationSchema={validationSchema} onSubmit={onSubmit} enableReinitialize>
          <Form name="update-customer">
            <FormItem name="tenantName" label="Tenant">
              <Input name="tenantName" placeholder="Tenant" disabled />
            </FormItem>
            <FormItem name="issuerName" label="Issuer">
              <Input name="issuerName" placeholder="Issuer" disabled />
            </FormItem>
            <FormItem name="customerCode" label="Customer ID" required>
              <Input name="customerCode" placeholder="Customer ID" />
            </FormItem>
            <FormItem name="customerType" label="Customer Type" required>
              <Select
                placeholder="Select a customer type"
                name="customerType"
                showSearch
                options={segmentTypeOptions}
                {...filterProps}
              />
            </FormItem>
            <SubmitButton htmlType="submit" type="primary">
              Update Customer
            </SubmitButton>
          </Form>
        </Formik>
      </Col>
    </Drawer>
  )
}
